<template>
  <div class='lifetime-fyf'>
    <div
      id='ahc-lifetime-find-your-future-wrapper'
      class="lifetime-fyf-wrapper"
    >
      <Scene :isLoading="isOnLoadingPage" />

      <main class="lt-fyf-main" role="main">
        <HeaderFyF />
        <transition name='lt-fyf-transition-all-pages-toggle'>
          <WelcomePage
            v-if="isOnPage('welcome')"
            v-show='showForeground'
          />

          <QPageCohabiting
            v-if="isOnPage('cohabiting')"
            v-show='showForeground'
          />
          <QPageLocation
            v-if="isOnPage('location')"
            v-show='showForeground'
          />
          <QPageHomeFurnishing
            v-if="isOnPage('homeFurnishing')"
            v-show='showForeground'
          />
          <QPageFood
            v-if="isOnPage('eatingIn')"
            v-show='showForeground'
          />
          <QPageEatingOut
            v-if="isOnPage('eatingOut')"
            v-show='showForeground'
          />
          <QPageTransport
            v-if="isOnPage('transport')"
            v-show='showForeground'
          />
          <QPageHolidays
            v-if="isOnPage('holidays')"
            v-show='showForeground'
          />
          <QPageTreats
            v-if="isOnPage('treats')"
            v-show='showForeground'
          />
          <QPagePersonal
            v-if="isOnPage('personal')"
            v-show='showForeground'
          />

          <LoadingPage v-if="isOnPage('loading')" />

          <ResultsPage
            v-if="isOnPage('results')"
            v-show='showForeground'
          />

          <DisclaimerAndAssumptionsPage
            v-if="isOnPage('disclaimer-and-assumptions')"
            v-show='showForeground'
          />
        </transition>

        <BackButton
          v-if='isOnQuestionPage'
          v-show='showForeground'
        />

        <ProgressBar
          v-if='isOnQuestionPage'
          v-show='showForeground'
        />
      </main>
    </div>
    <LifetimeFooter />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  data () {
    return {
    };
  },
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.currentPageIndex',
    ]),
    ...mapGetters([
      'isOnPage',
      'currentPage',
      'isOnQuestionPage',
    ]),
    isOnWelcomePage: function () {
      return this.isOnPage('welcome');
    },
    isOnLoadingPage: function () {
      return this.isOnPage('loading');
    },
  },
};
</script>

<style lang='scss'>

.lifetime-fyf {
  max-width: 1600px;
  font-family: $font-family;
  input, button {
    font-family: $font-family;
  }
}

.lifetime-fyf-wrapper {
  @include scut-ratio-box(16/10);
  overflow: hidden;

  @include breakpoint-portrait {
    @include scut-ratio-box(10/16);
  }

  // bit of a hack as on mobile screens the frame was too small for the questions
  @include breakpoint-mobile {
    @include scut-ratio-box(9/20);
  }
}

.lt-fyf-main {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 4%;
  left: 50%;
  padding: 0 2%;
  transform: translateX(-50%);
  max-width: $container-max-width;
  max-width: 1200px;
  width: 100%;
  z-index: 50;
}

.lt-fyf-transition-all-pages-toggle {
  &-enter-active:not(.lt-fyf-loading-page) {
    transition: opacity .5s linear;
  }
  &-enter, &-leave-to {
    &:not(.lt-fyf-loading-page) {
      opacity: 0;
    }
  }
}


</style>
